import React, {useCallback, useState} from 'react';

import {H6Text} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import {Modules} from '@buncha/utils/types';
import OnOffToggleSwitch from '@buncha/components/core/input/switch/OnOffToggleSwitch';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';
import {useUpdatePriceTagOrderItemProperties} from '@buncha/itemDetails/hooks/ItemScanner';

interface PriceTagToggleProps {
  hasPriceTag: boolean;
  orderItemId: number;
  runId: number;
  storeIndex: string;
}

const PriceTagToggle = (props: PriceTagToggleProps) => {
  const {hasPriceTag, orderItemId, runId, storeIndex} = props;
  const {body} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const [priceTagToggle, setPriceTagToggle] = useState(hasPriceTag);
  const {updateOrderItemProperties, loading} =
    useUpdatePriceTagOrderItemProperties();

  const toggleButton = useCallback(async () => {
    const newValue = !priceTagToggle;
    setPriceTagToggle(newValue);
    const res = await updateOrderItemProperties(
      orderItemId,
      runId,
      newValue,
      storeIndex,
    );
    if (!res) setPriceTagToggle(preValue => !preValue); // Additioanl check while api fail or getting error so need to revert the toggle again
  }, [
    orderItemId,
    priceTagToggle,
    runId,
    storeIndex,
    updateOrderItemProperties,
  ]);

  return (
    <HBox>
      <H6Text style={styles.textTitle}>{body?.priceTag}</H6Text>
      <OnOffToggleSwitch
        value={priceTagToggle}
        onToggle={toggleButton}
        disabled={loading}
      />
    </HBox>
  );
};

export default React.memo(PriceTagToggle);

const styles = StyleSheet.create({
  textTitle: {marginRight: 10},
});
